import React from 'react';
import styles from './Button.module.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'destructive';
type ButtonSize = 'md' | 'lg';

interface ButtonProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: React.ElementType<any>;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  to?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: React.MouseEventHandler;
}

export default function Button({
  variant = 'primary',
  size,
  as: Tag = 'button',
  disabled,
  children,
  className,
  type,
  ...rest
}: ButtonProps) {
  const resolvedSize = size ?? (variant === 'primary' || variant === 'destructive' ? 'lg' : 'md');
  const cls = [styles.base, styles[variant], styles[resolvedSize], className]
    .filter(Boolean)
    .join(' ');

  const isButton = Tag === 'button';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const El = Tag as any;

  return (
    <El
      type={isButton ? (type ?? 'button') : undefined}
      disabled={isButton ? disabled : undefined}
      className={cls}
      {...rest}
    >
      {children}
    </El>
  );
}
